import { useEffect } from "react";

// Moves focus into a dialog, closes it on Escape, and returns focus to
// whatever opened it.
const useDialog = (onClose, focusRef) => {
  useEffect(() => {
    const opener = document.activeElement;
    focusRef.current?.focus();
    const onKey = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("keydown", onKey);
      opener?.focus?.();
    };
  }, [onClose, focusRef]);
};

export default useDialog;
